import React, { useState, Component ,useEffect} from "react";
import { Container, Row, Col, Button, Alert, Form, Nav, Navbar, NavDropdown, Dropdown } from 'react-bootstrap';
import AdminContent from "../../../core/components/content/AdminContent";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import AllUser from "../user/AllUser";
import { faHelicopterSymbol } from "@fortawesome/free-solid-svg-icons";
import { NavLink , Outlet,useNavigate } from 'react-router-dom';
import { logout } from "../../login/loginSlice";
import { useSelector,useDispatch } from "react-redux";


const MasterPage = ({ children }) => {
    const dispatch = useDispatch();
    const navigate= useNavigate();
    const [sidebar, setSidebar] = useState(false);
    const [isTokenExpired, setIsTokenExpired] = useState(false);


    const showSidebar = () => setSidebar(!sidebar);
    {/* <>
    <nav>
        <NavLink  to="/">Home</NavLink >
        <NavLink  to="/dashboard">Dashboard</NavLink >
        <NavLink  to="/allusers">All Users</NavLink >
        <NavLink  to="/createUser">Add User</NavLink >
    </nav>
   
        <Outlet />
    
</> */}
const logMeOut = () => {
    sessionStorage.removeItem("accessJWT");
    sessionStorage.removeItem("accessIsLogIn");
    sessionStorage.removeItem("accessUserID");
    localStorage.removeItem("accessIsLogIn");
    localStorage.removeItem("islogIn");
    localStorage.removeItem("crmSite");
    localStorage.removeItem("accessUserID");
     // CLEAR DATA FROM STORAGE
     localStorage.clear();
     sessionStorage.clear();
    dispatch(logout());
    
    navigate('/login', { replace: true });
  //  window.location.reload(true);
  }

useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTokenExpired(true);
    }, 3600000); 
  
    return () => {
      clearTimeout(timeout);
    };
  }, [isTokenExpired]);

  if (isTokenExpired) {
    return (
      <Alert variant="danger">
        Your session has expired. Please log in again.<a onClick={logMeOut} style={{cursor:'pointer'}}>Click Here To Login</a>
      </Alert>
    );
  }
    return (
        <React.Fragment>

            <div className="main ">
                <Header />
                <div className="page-wrapper">
                    <Container fluid>
                    <Sidebar />
                        <Row>
                            <Col className="col-md-12"> 
                            <br />
                            <br />
                            <br />
                            <AdminContent>
                                {children}
                                
                            </AdminContent>
                          
                            </Col>
                            
                        </Row>
                        
                        
                    </Container>
                    {/* <Footer /> */}

                </div>
                
            </div>
        </React.Fragment>
    );
}

export default MasterPage;